module.exports = __webpack_public_path__ + "img/month.e0070839.png";